module.exports = __webpack_public_path__ + "img/Photo_7___Third_Canal_2007_5_45.053d7d26.jpg";